import React from 'react';
import TempInspectionFrom from "../../../../_common/components/TempInspectionForm";
import {TempInspectionContextType} from "../../../contexts/TempInspectionContext";

type TempInspectionProps = {
  orderID: number
  useContext: () => TempInspectionContextType
  index: number
}

const TempInspection = ({useContext, orderID, index}: TempInspectionProps) => {
  const {
    formikTempInspection,
    decisionTreeProps,
    fieldNames
  } = useContext();

  return (
    <TempInspectionFrom
      index={index}
      fieldNames={fieldNames}
      decisionTreeProps={decisionTreeProps}
      disabledFormCondition={orderID}
      values={formikTempInspection.values}
      setFieldValue={formikTempInspection.setFieldValue}
      handleChange={formikTempInspection.handleChange}
    />
  )
};

export default TempInspection;
